module.exports = __webpack_public_path__ + "img/facebook.e6894d1.png";